{"name": "nextgen-bitbrew-web", "buildversion": "1.0.14_SNAPSHOT_11032026-123350", "buildTime": "03/11/2026 12:33:50"}